import React from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation, Trans } from 'react-i18next'
import Link from 'ui/components/link'
import { submitOwnerStep } from 'services/customer/actions'
import { Button, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'
import Typography from 'ui/components/typography'

import useStyles from './styles'

const Retargeting = ({ handleClose, data: formData }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const submitRetargeting = (valueRetargeting) => {
    const formDataWithRetargeting = {
      ...formData,
      retargeting: valueRetargeting,
    }
    handleClose()
    dispatch(submitOwnerStep(formDataWithRetargeting))
  }
  return (
    <>
      <DialogTitle disableTypography className={classes.dialogTitle} id="customized-dialog-title">
        <Typography variant="h4">{t('retargeting.title')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Typography variant="basic">
          <Trans i18nKey="retargeting.text">
            <Link underline="always" href={t('common.privacyPolicyUrl')} target="_blank"></Link>
          </Trans>
        </Typography>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button type="submit" color="secondary" variant="outlined" onClick={() => submitRetargeting(false)}>
          {t('common.dontAgree')}
        </Button>
        <Button type="submit" color="secondary" variant="contained" onClick={() => submitRetargeting(true)}>
          {t('common.agree')}
        </Button>
      </DialogActions>
    </>
  )
}

export default Retargeting
